import { render, staticRenderFns } from "./AddWorkOrderChargeModal.vue?vue&type=template&id=23f2ddbc&"
import script from "./AddWorkOrderChargeModal.vue?vue&type=script&lang=js&"
export * from "./AddWorkOrderChargeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports